// extracted by mini-css-extract-plugin
export var btn = "QuaternaryCard-module--btn--7a49e";
export var checklist = "QuaternaryCard-module--checklist--253b8";
export var contentContainer = "QuaternaryCard-module--contentContainer--a0557";
export var heading = "QuaternaryCard-module--heading--c5d63";
export var image = "QuaternaryCard-module--image--c10e3";
export var quaternary = "QuaternaryCard-module--quaternary--1d284";